import React from "react";

function Blank() {
  return <div>Blank</div>;
}

export default Blank;
